// import components
import { DefaultReadModeRenderer } from './withReadModeFieldRenderers';

// import context
import { useEditPageContext } from '../EditPageContext';

// types
import type { ComponentType } from 'react';
import type { WithReadModeFieldPropsBase } from './withReadModeField.types';

type Props<T> = T &
  WithReadModeFieldPropsBase & {
    readModeRenderer?: ComponentType<WithReadModeFieldPropsBase & any>;
  };

const withReadModeField =
  <CProps extends object>(Component: React.FC<CProps>) =>
  (props: Props<CProps>) => {
    const { isEditable: contextIsEditable } = useEditPageContext();
    const isEditable =
      props.disabled !== undefined ? !props.disabled : contextIsEditable;

    if (!isEditable) {
      if (props.readModeRenderer) {
        const ReadModeRenderer = props.readModeRenderer;

        return (
          <ReadModeRenderer {...props} name={props.name} label={props.label} />
        );
      }

      return (
        <DefaultReadModeRenderer
          name={props.name}
          label={props.label}
          options={props.options}
          labelGetter={props.labelGetter}
          valueGetter={props.valueGetter}
          valueFormatter={props.valueFormatter}
          disableLabel={props.disableLabel}
        />
      );
    }

    return <Component {...props} disabled={!isEditable} />;
  };

export default withReadModeField;
